export default "__VITE_ASSET__CsN6iNTb__"